angular.module('signature', [])
angular.module('signature').constant('SignaturePad', require('signature_pad'));

angular.module('signature').directive('signaturePad', ['$interval', '$timeout', '$window', 'SignaturePad',
  function ($interval, $timeout, $window, SignaturePad) {
    'use strict';

    let signaturePad, element, EMPTY_IMAGE = 'data:image/png;base64,';

    return {
      restrict: 'EA',
      replace: true,
      template: `
        <div class="signature signature-pad-wrapper" style="width: 100%; max-width:{{width}}px; height: 100%; max-height:{{height}}px; position: relative;">
          <canvas style="display: block; margin: 0 auto;" ng-mouseleave="onMouseEnd()" ng-mouseup="onMouseEnd()" ng-mousedown="onMouseStart()">
          </canvas>
        </div>`,
      scope: {
        accept: '=?',
        clear: '=?',
        disabled: '=?',
        dataurl: '=?',
        hasData: '=?',
        height: '@',
        width: '@',
        color: '@',
        fieldWidth: '@',
        viewportWidth: '@'
      },
      controller: [
        '$scope', '$timeout',
        function ($scope, $timeout) {
          $scope.hasData = false;
          $scope.accept = function () {
            return {
              isEmpty: !$scope.hasData,
              dataUrl: $scope.dataurl
            };
          };

          $scope.onMouseEnd = function () {
            $scope.updtModel();
          };

          $scope.onMouseStart = function () {
            $scope.hasData = true;
          }

          $scope.updtModel = function () {
            /*
                            defer handling mouseup event until $scope.signaturePad handles
                            first the same event
                            */
            $timeout().then(function () {
              if (!$scope.hasData) {
                $scope.dataurl = EMPTY_IMAGE;
                return;
              }
              $scope.dataurl = $scope.signaturePad.toDataURL();
            });
          };

          $scope.clear = function () {
            $scope.hasData = false;
            $scope.signaturePad.clear();
            $scope.dataurl = EMPTY_IMAGE;
          };

          $scope.$watch("dataurl", function (dataUrl) {
            if (!dataUrl || !$scope.signaturePad || $scope.signaturePad.toDataURL() === dataUrl) return;
            $scope.setDataUrl(dataUrl);
          });
        }
      ],

      link: function (scope, element, attrs) {

        var canvas = element.find('canvas')[0];
        var parent = canvas.parentElement;
        var scale = 0;
        var ctx = canvas.getContext('2d');

        var fieldWidth = parseInt(scope.fieldWidth, 10);
        var viewportWidth = parseInt(scope.viewportWidth, 10);
        var width = parseInt(scope.width, 10);
        var height = parseInt(scope.height, 10);

        var relativeFieldWidth = (fieldWidth / viewportWidth) * 0.08;
        var relativePadWidth = (viewportWidth / width) * 0.2;
        var weight = (viewportWidth / 100000);
        var penWidth = weight / (relativeFieldWidth * relativePadWidth);
        penWidth = Math.ceil(penWidth);

        canvas.width = width;
        canvas.height = height;
                
        scope.signaturePad = new SignaturePad(canvas, {
          minWidth: Math.ceil(penWidth * 0.8),
          maxWidth: penWidth,
          penColor: scope.color || 'black'
        });

        scope.setDataUrl = function (dataUrl) {
          var ratio = Math.max(window.devicePixelRatio || 1, 1);

          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.scale(ratio, ratio);

          scope.signaturePad.clear();
          scope.signaturePad.fromDataURL(dataUrl);

          $timeout().then(function () {
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.scale(1 / scale, 1 / scale);
          });
        };

        scope.$watch('disabled', function (val) {
          val ? scope.signaturePad.off() : scope.signaturePad.on();
        });

        var calculateScale = function () {
          var scaleWidth = Math.min(parent.clientWidth / width, 1);
          var scaleHeight = Math.min(parent.clientHeight / height, 1);

          var newScale = Math.min(scaleWidth, scaleHeight);

          if (newScale === scale) {
            return;
          }

          var newWidth = width * newScale;
          var newHeight = height * newScale;
          canvas.style.height = Math.round(newHeight) + "px";
          canvas.style.width = Math.round(newWidth) + "px";

          scale = newScale;
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.scale(1 / scale, 1 / scale);
        };

        var resizeIH = $interval(calculateScale, 200);
        scope.$on('$destroy', function () {
          $interval.cancel(resizeIH);
          resizeIH = null;
        });

        angular.element($window).bind('resize', calculateScale);
        scope.$on('$destroy', function () {
          angular.element($window).unbind('resize', calculateScale);
        });

        calculateScale();

        element.on('touchstart', onTouchstart);
        element.on('touchend', onTouchend);

        function onTouchstart(event) {
          scope.hasData = true;
          event.preventDefault();
        }

        function onTouchend(event) {
          scope.$apply(function () {
            scope.updtModel();
          });
          event.preventDefault();
        }
      }
    }
  }
]);

// Backward compatibility
angular.module('ngSignaturePad', ['signature']);